<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
    <div class="box">
      <div class="block">
        <BInputWithValidation
          rules="max:50"
          type="text"
          label="Name"
          v-model="tagCopy.name"
        />
      </div>
      <div class="block">
        <b-field>
          <b-checkbox v-model="tagCopy.commonly_searched">
            Is commonly searched?
          </b-checkbox>
        </b-field>
      </div>
    </div>
    <div class="block" v-if="error">
      <b-message type="is-danger">
        <span v-html="error" />
      </b-message>
    </div>
    <div class="is-flex" style="justify-content: end">
      <div class="buttons">
        <b-button @click="$emit('close')" v-if="showCloseBtn"
          >Schließen</b-button
        >
        <b-button
          type="is-gold"
          :disabled="invalid"
          @click="handleSubmit(submit)"
        >
          Speichern
        </b-button>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex';

import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';

export default {
  name: 'TagEdit',
  components: {
    BInputWithValidation,
  },
  props: {
    tag: {
      required: true,
    },
    showCloseBtn: {
      type: Boolean,
      default: false,
    },
    tagDropup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagCopy: { ...this.tag },
    };
  },
  computed: {
    ...mapGetters({
      error: 'tag/error',
    }),
  },
  watch: {
    tag: {
      deep: true,
      handler(newVal) {
        this.tagCopy = { ...newVal };
      },
    },
  },
  methods: {
    submit() {
      const payload = { ...this.tagCopy };
      this.$emit('submitted', payload);
    },
  },
};
</script>

<style>
</style>
